var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',[_c('HeadMetadata',{attrs:{"title":_vm.pageTitle}}),_c('PageHeading',{attrs:{"heading":_vm.pageName}}),_c('SearchBar',{attrs:{"label":"Keyword"}}),_c('SearchResults')],1),_c('BriefcaseFolderMoveDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }